import api from "./api";

export const getsSalon = async () => {
    const response = await api.get("/Salon/GetsSalon");

    return response.data.data;
};

export const addUpdateSalon = async (dto) => {
    const response = await api.post("/Salon/AddUpdateSalon", dto);

    return response.data.data;
};

export const deleteSalon = async (id) => {
    const response = await api.delete("/Salon/DeleteSalon?id=" + id);

    return response.data.data;
};
